export const getImageUrl = (device: string, imgName: string) =>
  `/assets/widgets/modals/ScenarioTestLaunchModal/${device}/${imgName}`;
